var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.251,
    height: 22.251,
    viewBox: "0 0 22.251 22.251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "contract") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#7c7c7c;stroke-width:0.3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-223.36 -152.832)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(223.572 153.044)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.206,7.3V8.662H7.98a.682.682,0,0,0,.682-.682V3.206H7.3V6.336L.962,0,0,.962,6.336,7.3Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M309.482,8.662h4.774V7.3h-3.131l3.444-3.444L317.462.962,316.5,0l-6.336,6.336V3.206H308.8V7.98A.682.682,0,0,0,309.482,8.662Z",
    transform: "translate(-295.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M310.164,311.126l6.336,6.336.962-.962-6.336-6.336h3.131V308.8h-4.774a.682.682,0,0,0-.682.682v4.774h1.364Z",
    transform: "translate(-295.636 -295.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.962,317.31,7.3,310.966V314.1H8.662v-4.775a.682.682,0,0,0-.682-.682H3.206V310H6.336L0,316.341Z",
    transform: "translate(0 -295.483)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.932db730ef25bbc625cca59f39badd50.svg";
export { ForwardRef as ReactComponent };